
export const defaultInbox: InboxProps = { numeroSeguimiento: '', proceso: '', tipoTramite: '', actividad: '', path: '', fecha: '', referencia: '', noReferencia: '', folioBuzonElectronico: '', provieneBuzonElectronico: false, delegado: false, usuarioDelegado: false, };

export interface InboxProps {
    numeroSeguimiento:              string;
    proceso:                        string;
    tipoTramite:                    string;
    actividad:                      string;
    path:                           string;
    fecha:                          string;
    referencia:                     string;
    noReferencia:                   string;  
    folioBuzonElectronico:          string;
    provieneBuzonElectronico:       boolean;
    delegado:                       boolean;
    usuarioDelegado:                boolean;    
    fechaOrder?:                    Date;    
}

export interface AsignarActividadParams {
    numeroSeguimiento:              string; 
}